// extracted by mini-css-extract-plugin
export default {"container":"SmallZodiacCard_container__2Tmtm","title":"SmallZodiacCard_title__g0B1N","selectedTitle":"SmallZodiacCard_selectedTitle__h9xgA","circle":"SmallZodiacCard_circle__A355Y"};